<template>
<div>
    <span class="d-flex align-items-center">
        <i
            class="ni-2x mdi mdi-circle pr-1"
            :class="{
                'mdi-image' : file.type === 'image',
                'mdi-file' : file.type === 'pdf',
                'mdi-play' : file.type === 'video'}"
        />
        {{file.filename}}
    </span>
    <!-- Start Protected file -->
    <div
        v-if="file.config && (file.download.status==='none' || file.download.status === 'processing')"
    >
        <base-button
            download
            v-if="downloadUrl"
            @click="generateDownload(file)"
        >
            <i class="fa fa-download"/>
            Download File
        </base-button>
        <base-button
            download
            v-else
            :disabled="file.download.status==='processing'"
            @click="generateDownload(file)"
        >
            <i :class="file.download.status==='processing' ? 'fa fa-spinner fa-spin' : 'fa fa-upload'"/>
            Request file
        </base-button>
    </div>
    <!-- End Protected file -->
    <div v-else style="width: fit-content">
        <base-button
            class="mr-0"
            :class="[{'disable-border-radious-bottom': progressDownload || file.download.status === 'downloading'}]"
            download
            :disabled="file.download.status==='downloading'"
            :key="file.id"
            @click="downloadFile(file)"
        >
            <i :class="file.download.status==='downloading' ? 'fa fa-spinner fa-spin' : 'fa fa-download'"/>
            Download
        </base-button>
        <base-progress
            v-show="progressDownload || file.download.status === 'downloading'"
            class="progress-bar-elevation"
            type="primary"
            :height="5"
            :value="progressDownload"
            progress-classes="disable-border-radious-top mb-0"
        />
    </div>
</div>
</template>

<script>
import BaseButton from '../../../../argon/components/BaseButton';
import BaseProgress from '../../../../argon/components/BaseProgress';

export default {
    name: 'ContentDownload',
    props: {
        content: Object,
        file: Object,
    },
    components: {
        BaseButton,
        BaseProgress,
    },
    data() {
        return {
            downloadUrl: false,
            progressDownload: 0,
        };
    },
    computed: {
        language() {
            return this.$store.getters.LANGUAGE;
        },
    },
    created() {
        this.registerBroadcast();
    },
    methods: {
        registerBroadcast() {
            // caso o download ja tenha sido requisitado e foi gerado nao há necessidade do websocket persistir em monitorar
            if (this.file.download.status === 'processing') {
                window.EchoAssets.channel(`${process.env.MIX_ASSETS_SOCKET}cdn`)
                    .listen('ProcessedWatermarkEvent', (e) => {
                        const watermarkHash = !!e.watermark.watermark
                            ? e.watermark.watermark.hash
                            : e.watermark.hash;
                        if (
                            this.file.config &&
                            this.file.config.watermark_file.hash === watermarkHash
                        ) {
                            this.setStatus('complete');
                            this.downloadUrl = this.getDownloadUrl();

                            // atualizar o processo do arquivo no banco
                            this.updateFileStatus();
                        }
                    });
            } else if (this.file.download.status === 'complete') {
                this.downloadUrl = this.getDownloadUrl();
            }
        },
        generateDownload(file) {
            window.axios.get(`/app/files/generate/${this.content.id}/${file.secret}`, {
                params: {
                    watermark: 1,
                },
            }).then((response) => {
                this.file.download = response.data.data.download;
                this.registerBroadcast();
            });
        },
        getDownloadUrl() {
            return `/app/files/download/${this.content.id}/${this.file.secret}`;
        },
        async resetDownloadStatus(file) {
            if (file.download && file.download.id) {
                try {
                    await window.axios.put(`/app/files/download_status/${file.download.id}`, {
                        status: 'none'
                    });
                    this.setStatus('none');
                    this.downloadUrl = false;
                } catch (e) {
                    console.error('Error resetting download status:', e);
                }
            }
        },
        async updateFileStatus() {
            const downloadStatus = await window.axios.put(`/app/files/download_status/${this.file.download.id}`);
            this.setStatus(downloadStatus.data.download_status);
        },
        downloadFile(file) {
            this.setStatus('downloading');

            window.axios(`/app/files/download/${this.content.id}/${file.secret}`, {
                responseType: 'blob', // important
                onDownloadProgress: (progress) => {
                    this.progressDownload = (progress.loaded * 100) / this.file.size;
                },
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', file.filename);
                document.body.appendChild(link);
                link.click();

                this.setStatus('complete');
            }).catch((error) => {
                this.setStatus('complete');

                if (error.response) {
                    const status = error.response.status;

                    if (status === 401) {
                        this.$notify({
                            message: this.$t('content.uploads.rules_failed'),
                            type: 'warning',
                        });
                    } else if (status === 410) {
                        this.resetDownloadStatus(file);
                        this.$notify({
                            message: 'Arquivo expirou. Clique novamente para gerar um novo download.',
                            type: 'info',
                        });
                    } else if (status === 404) {
                        this.resetDownloadStatus(file);
                        this.$notify({
                            message: 'Arquivo não encontrado. Clique novamente para gerar um novo download.',
                            type: 'warning',
                        });
                    }
                }
            });
        },
        setStatus(status) {
            this.$store.commit('CLASS_SET_FILE_DOWNLOAD_STATUS', { id: this.file.id, status });
        },
    },
};
</script>

<style scoped>
.progress-bar-elevation{
    transform: translateY(-1px);
}
.disable-border-radious-bottom {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
